<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!!estado_id"
                        :options="form.estados"
                        :validations="validations.estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.estado_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :disabled="!model.estado_id || !!municipio_id"
                        :fields="fields.municipio"
                        :repository="repositories.comum.municipio"
                        :request-params="{estado_id: model.estado_id}"
                        :selected-text="model.municipio_nome"
                        :validations="validations.municipio_id"
                        label="Município"
                        v-model="model.municipio_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :disabled="!model.municipio_id"
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        ...mapGetters({cliente: 'getCliente'}),
        fields() {
            return {
                municipio: [
                    {key: 'nome', name: 'cadastro_municipio.nome'},
                ],
            }
        },
        loading() {
            return this.getLoading('cadastro-bairro-form')
        },
        validations() {
            return {
                estado_id: { required: true },
                municipio_id: { required: true },
                nome: {
                    required: true,
                    min: 3,
                    max: 180,
                },
            }
        },
    },
    data: () => ({
        form: {
            estados: [],
        },
        model: {
            estado_id: null,
            municipio_id: null,
            municipio_nome: null,
            nome: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('cadastro-bairro-form')

            if (this.id) {
                this.repositories.cadastro.bairro.edit(this.id)
                    .then(({ data }) => {
                        this.form.estados = data.form.estados
                        this.model.estado_id = data.model.estado_id
                        this.model.municipio_id = data.model.municipio_id
                        this.model.municipio_nome = data.model.municipio_nome,
                        this.model.nome = data.model.nome
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-bairro-form'))
            } else {
                this.repositories.cadastro.bairro.create()
                    .then(({ data }) => {
                        this.form.estados = data.form.estados
                        this.model.estado_id = this.estado_id || this.cliente.municipio.estado.id || null
                        this.model.municipio_id = this.municipio_id || this.cliente.municipio.id || null
                        this.model.municipio_nome = this.municipio_nome || this.cliente.municipio.nome || null
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-bairro-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-bairro-form')

                        const request = {
                            municipio_id: this.model.municipio_id,
                            nome: this.model.nome,
                        }

                        if (this.id) {
                            this.repositories.cadastro.bairro.update(request, this.id)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-bairro-form'))
                        } else {
                            this.repositories.cadastro.bairro.store(request)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-bairro-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        estado_id: {type: Number, default: null},
        id: {type: Number},
        municipio_id: {type: Number},
        municipio_nome: {type: String},
    },
}
</script>